import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import AdminApi from '../../api/adminApi';
import './Admin.css';

const AdminDashboard = () => {
  const [reclutamientos, setReclutamientos] = useState({});
  const [selectedReclutamiento, setSelectedReclutamiento] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    // Verificar autenticación
    if (!localStorage.getItem('adminAuthenticated') || !localStorage.getItem('adminAuth')) {
      navigate('/admin');
      return;
    }

    loadReclutamientos();
  }, [navigate]);

  const loadReclutamientos = async () => {
    try {
      setLoading(true);
      const data = await AdminApi.getAllReclutamientos();
      setReclutamientos(data);
    } catch (err) {
      setError('Error al cargar las postulaciones');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleViewDetails = async (id) => {
    try {
      const detalle = await AdminApi.getReclutamientoDetalle(id);
      setSelectedReclutamiento(detalle);
    } catch (err) {
      setError('Error al cargar los detalles');
      console.error(err);
    }
  };

  const handleDownload = async (documentoId, nombreArchivo) => {
    try {
      const blob = await AdminApi.downloadDocumento(documentoId);
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = nombreArchivo;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    } catch (err) {
      setError('Error al descargar el archivo');
      console.error(err);
    }
  };

  const handleLogout = () => {
    AdminApi.logout();
    localStorage.removeItem('adminAuthenticated');
    navigate('/admin');
  };

  if (loading) {
    return <div className="admin-loading">Cargando postulaciones...</div>;
  }

  if (error && Object.keys(reclutamientos).length === 0) {
    return <div className="admin-error">{error}</div>;
  }

  return (
    <div className="admin-dashboard">
      <div className="admin-header">
        <h1>Panel de Administración - Postulaciones</h1>
        <button onClick={handleLogout} className="admin-logout-button">
          Cerrar Sesión
        </button>
      </div>

      {error && <div className="admin-error-message">{error}</div>}

      {selectedReclutamiento ? (
        <div className="admin-detail-view">
          <button onClick={() => setSelectedReclutamiento(null)} className="admin-back-button">
            ← Volver a la lista
          </button>
          <div className="admin-detail-content">
            <h2>{selectedReclutamiento.nombreCompleto}</h2>
            <div className="admin-detail-section">
              <h3>Información Personal</h3>
              <p><strong>Email:</strong> {selectedReclutamiento.email}</p>
              <p><strong>Edad:</strong> {selectedReclutamiento.edad}</p>
              <p><strong>Residencia:</strong> {selectedReclutamiento.residencia}</p>
              <p><strong>Área:</strong> {selectedReclutamiento.area || 'N/A'}</p>
              <p><strong>Rol:</strong> {selectedReclutamiento.rolNombre || 'N/A'}</p>
              <p><strong>Idiomas:</strong> {selectedReclutamiento.idiomas?.join(', ') || 'N/A'}</p>
              <p><strong>Fecha de postulación:</strong> {new Date(selectedReclutamiento.fechaPostulacion).toLocaleString()}</p>
            </div>

            <div className="admin-detail-section">
              <h3>Experiencia</h3>
              <p>{selectedReclutamiento.experiencia}</p>
            </div>

            {selectedReclutamiento.portafolio && (
              <div className="admin-detail-section">
                <h3>Portafolio</h3>
                <a href={selectedReclutamiento.portafolio} target="_blank" rel="noopener noreferrer">
                  {selectedReclutamiento.portafolio}
                </a>
              </div>
            )}

            {selectedReclutamiento.evaluacionDetallada && (
              <div className="admin-detail-section">
                <h3>Evaluación Detallada</h3>
                <div className="evaluacion-detallada">
                  <p><strong>Pregunta 1:</strong> {selectedReclutamiento.evaluacionDetallada.pregunta1}</p>
                  <p><strong>Pregunta 2:</strong> {selectedReclutamiento.evaluacionDetallada.pregunta2}</p>
                  <p><strong>Pregunta 3:</strong> {selectedReclutamiento.evaluacionDetallada.pregunta3}</p>
                  <p><strong>Pregunta Abierta 1:</strong> {selectedReclutamiento.evaluacionDetallada.preguntaAbierta1}</p>
                  <p><strong>Pregunta Abierta 2:</strong> {selectedReclutamiento.evaluacionDetallada.preguntaAbierta2}</p>
                  <p><strong>Pregunta Abierta 3:</strong> {selectedReclutamiento.evaluacionDetallada.preguntaAbierta3}</p>
                  <p><strong>Pregunta Abierta 4:</strong> {selectedReclutamiento.evaluacionDetallada.preguntaAbierta4}</p>
                  <p><strong>Pregunta Abierta 5:</strong> {selectedReclutamiento.evaluacionDetallada.preguntaAbierta5}</p>
                  <p><strong>Pregunta Abierta 6:</strong> {selectedReclutamiento.evaluacionDetallada.preguntaAbierta6}</p>
                  <p><strong>Pregunta Abierta 7:</strong> {selectedReclutamiento.evaluacionDetallada.preguntaAbierta7}</p>
                  <p><strong>Pregunta Abierta 8:</strong> {selectedReclutamiento.evaluacionDetallada.preguntaAbierta8}</p>
                  <p><strong>Pregunta Abierta 9:</strong> {selectedReclutamiento.evaluacionDetallada.preguntaAbierta9}</p>
                  <p><strong>Pregunta Abierta 10:</strong> {selectedReclutamiento.evaluacionDetallada.preguntaAbierta10}</p>
                  <p><strong>Fecha de respuesta:</strong> {new Date(selectedReclutamiento.evaluacionDetallada.fechaRespuesta).toLocaleString()}</p>
                </div>
              </div>
            )}

            {selectedReclutamiento.documentos && selectedReclutamiento.documentos.length > 0 && (
              <div className="admin-detail-section">
                <h3>Archivos Adjuntos</h3>
                <ul className="documentos-list">
                  {selectedReclutamiento.documentos.map((doc) => (
                    <li key={doc.id}>
                      <span>{doc.nombreArchivo}</span>
                      <button
                        onClick={() => handleDownload(doc.id, doc.nombreArchivo)}
                        className="admin-download-button"
                      >
                        Descargar
                      </button>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </div>
      ) : (
        <div className="admin-list-view">
          {Object.keys(reclutamientos).length === 0 ? (
            <p>No hay postulaciones</p>
          ) : (
            Object.entries(reclutamientos).map(([area, idiomasMap]) => (
              <div key={area} className="admin-area-section">
                <h2>{area}</h2>
                {Object.entries(idiomasMap).map(([idiomas, postulaciones]) => (
                  <div key={idiomas} className="admin-idioma-section">
                    <h3>Idiomas: {idiomas}</h3>
                    <table className="admin-table">
                      <thead>
                        <tr>
                          <th>Nombre</th>
                          <th>Email</th>
                          <th>Rol</th>
                          <th>Fecha</th>
                          <th>Acciones</th>
                        </tr>
                      </thead>
                      <tbody>
                        {postulaciones.map((post) => (
                          <tr key={post.id}>
                            <td>{post.nombreCompleto}</td>
                            <td>{post.email}</td>
                            <td>{post.rolNombre || 'N/A'}</td>
                            <td>{new Date(post.fechaPostulacion).toLocaleDateString()}</td>
                            <td>
                              <button
                                onClick={() => handleViewDetails(post.id)}
                                className="admin-view-button"
                              >
                                Ver Detalles
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                ))}
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
};

export default AdminDashboard;

